import { render } from "./TechnicalIssue.vue?vue&type=template&id=e6716fc8&scoped=true"
import script from "./TechnicalIssue.vue?vue&type=script&lang=js"
export * from "./TechnicalIssue.vue?vue&type=script&lang=js"

import "./TechnicalIssue.vue?vue&type=style&index=0&id=e6716fc8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6716fc8"]])

export default __exports__